export default __webpack_public_path__ + "locales/en/Webhooks.json?hash=e9c08ceb916432b89db8f1c491b075b9";